(function() {
    'use strict';

    angular
        .module('app.classes.versionMapping', [])
        .service("versionMappingService", ['frontEndSettingsService', '$q',
            function(frontEndSettingsService, $q) {
                var registeredFunctions = {};

                /* Register function call as name with some version.
                   Function with a name and version can be registered only once. */
                function registerFunction(reg) {
                    if (!registeredFunctions[reg.name]) {
                        registeredFunctions[reg.name] = [];
                    }
                    for (var i = 0; i < registeredFunctions[reg.name].length; i++) {
                        if (registeredFunctions[reg.name][i].version === reg.version) {
                            return;
                        }
                    }
                    registeredFunctions[reg.name].push(
                        {
                            version: reg.version,
                            func: reg.func,
                            options: reg.options
                        });
                    /* sort desc by version (mutates state) */
                    registeredFunctions[reg.name].sort(compare);
                }

                /* Sorts function call by version in descending order. */
                function compare(a, b) {
                    if (a.version < b.version)
                        return 1;
                    if (a.version > b.version)
                        return -1;
                    return 0;
                }

                /* Return registered function with highest compatible server version. Example:
                   already registered function getScenes v1.5.0.0,
                                      function getScenes v1.5.6.0,
                                      function getScenes v0.0.0.0 (default),
                   the client would like to call getScenes and its Homeserver version is 1.4.6.5.
                   1.5.6.0 > 1.4.6.5 => next 1.5.0.0 > 1.4.6.5 => next 0.0.0.0 <= 1.4.6.5 => call 0.0.0.0 version. */
                function recallFunction(functionName, options) {
                    let defer = $q.defer();

                    frontEndSettingsService.getFrontendSettings()
                    .then(function(settings) {
                        if (registeredFunctions[functionName]) {
                            for (var i = 0; i < registeredFunctions[functionName].length; i++) {
                                const func = registeredFunctions[functionName][i];
                                if (versionCompare(
                                        settings.HomeServerVersion,
                                        func.version,
                                        { zeroExtend: true }
                                    ) >= 0)
                                {
                                    if (options
                                        && func.options
                                        && options.configVersion) {
                                            if (func.options.minConfigVersion <= options.configVersion) {
                                                defer.resolve(func.func);
                                                console.log('recalled: ' + func.func());
                                                return defer.promise;
                                            }
                                            else {
                                                continue;
                                            }
                                    }
                                    else {
                                        defer.resolve(func.func);
                                        return defer.promise;
                                    }
                                }
                            }
                            console.error('Data for registered function "' + functionName + '" not available for HomeServer version ' + settings.HomeServerVersion);
                        }
                    });

                    return defer.promise;
                }

                /* Compare two string versions, e.g. 1.5.1.0 and 1.5.0.0 as numeric versions.

                    versionCompare('1.5.3.0','1.5.12.0') => -1
                    versionCompare('1.5.12.0','1.5.3.0') => +1
                    versionCompare('1.5.0.0','1.5.0.0')  => 0

                   https://stackoverflow.com/a/6832721 */
                function versionCompare(v1, v2, options) {
                    var lexicographical = options && options.lexicographical,
                        zeroExtend = options && options.zeroExtend,
                        v1parts = v1.split('.'),
                        v2parts = v2.split('.');

                    function isValidPart(x) {
                        return (lexicographical ? /^\d+[A-Za-z]*$/ : /^\d+$/).test(x);
                    }

                    if (!v1parts.every(isValidPart) || !v2parts.every(isValidPart)) {
                        return NaN;
                    }

                    if (zeroExtend) {
                        while (v1parts.length < v2parts.length) v1parts.push("0");
                        while (v2parts.length < v1parts.length) v2parts.push("0");
                    }

                    if (!lexicographical) {
                        v1parts = v1parts.map(Number);
                        v2parts = v2parts.map(Number);
                    }

                    for (var i = 0; i < v1parts.length; ++i) {
                        if (v2parts.length === i) {
                            return 1;
                        }

                        if (v1parts[i] === v2parts[i]) {
                            continue;
                        } else if (v1parts[i] > v2parts[i]) {
                            return 1;
                        } else {
                            return -1;
                        }
                    }

                    if (v1parts.length !== v2parts.length) {
                        return -1;
                    }

                    return 0;
                }

                return {
                    registerFunction: registerFunction,
                    recallFunction: recallFunction,
                    versionCompare: versionCompare
                };
            }
        ]);

})();
